import styled from 'styled-components'

export const LoadingContainer = styled.div`
    position: relative;
    flex-basis: 100%;

    height: 40px;
`